import { ApiService } from 'src/app/shared';
import { Injectable } from '@angular/core';
import { NewMemberSimpleDto } from '../dto/new-member.dto';
import { InvoiceWithPaymentDto } from 'src/app/invoices/dto/invoice-with-payment.dto';

@Injectable({
  providedIn: 'root',
})
export class NewMemberService {
  constructor(private _apiService: ApiService) {}

  updateProfileAsNewMember(profileId: number, dto: NewMemberSimpleDto) {
    return this._apiService.put(`NewMember/${profileId}/Simple`, dto);
  }

  createInvoice(memberProfileId: number, invoiceWithPayment: InvoiceWithPaymentDto) {
    return this._apiService.post(`NewMember/${memberProfileId}/Invoices`, invoiceWithPayment);
  }
}
